



























































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'

@Component
export default class SummaryDrawer extends Mixins(BaseComponent) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Prop({ default: () => {} })
  protected summary!: ApiGeneralSinglePayload

  protected get colLabelSpan(): number {
    return this.isMobile ? 9 : 3
  }
  protected get colValueSpan(): number {
    return this.isMobile ? 12 : 3
  }
}
